// Card Personalization Edit Enhancement
// Fixes issues when editing cart items with personalization data
// Specifically handles e-card "send immediately" checkbox state restoration

document.addEventListener('DOMContentLoaded', function() {
  console.log('🎯 Card Personalization Edit: Initializing...');
  
  // Wait a bit for the page to fully load, then set up monitoring
  setTimeout(() => {
    setupEditModeMonitoring();
  }, 1000);
  
  function setupEditModeMonitoring() {
    console.log('🔍 Setting up edit mode monitoring...');
    
    // Check if we're in edit mode by looking for URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const editCartItem = urlParams.get('edit_cart_item');
    
    if (editCartItem) {
      console.log('📝 Edit mode detected for item:', editCartItem);
      
      // Monitor for when form fields get populated
      setupFieldPopulationWatcher();
    }
  }
  
  function setupFieldPopulationWatcher() {
    console.log('👀 Setting up field population watcher...');
    
    // Check every 500ms for populated fields, then apply our fix
    const checkInterval = setInterval(() => {
      const messageField = document.getElementById('personalized-message');
      const ecardSendDateField = document.getElementById('ecard-send-datetime');
      
      // If message field has been populated, form population is likely complete
      if (messageField && messageField.value && messageField.value.trim() !== '') {
        console.log('📝 Form fields populated, applying send immediately fix...');
        
        // Apply our fix
        setTimeout(() => {
          fixSendImmediatelyCheckbox();
        }, 200);
        
        // Stop checking
        clearInterval(checkInterval);
      }
    }, 500);
    
    // Stop checking after 30 seconds to avoid infinite loop
    setTimeout(() => {
      clearInterval(checkInterval);
      console.log('⏰ Stopped watching for field population after timeout');
    }, 30000);
  }
  
  function fixSendImmediatelyCheckbox() {
    console.log('🔧 Applying send immediately checkbox fix...');
    
    const ecardSendDateField = document.getElementById('ecard-send-datetime');
    const sendImmediatelyCheckbox = document.getElementById('send-immediately-checkbox');
    const datetimePickerField = document.getElementById('datetime-picker-field');
    
    if (!ecardSendDateField || !sendImmediatelyCheckbox) {
      console.log('❌ E-card fields not found, cannot apply fix');
      return;
    }
    
    // Get the current value in the datetime field
    const currentDatetimeValue = ecardSendDateField.value;
    console.log('🔍 Current datetime field value:', currentDatetimeValue);
    
    // Also fetch the cart data to get the actual stored property
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const urlParams = new URLSearchParams(window.location.search);
        const editCartItem = urlParams.get('edit_cart_item');
        const itemIndex = parseInt(editCartItem) - 1;
        const cartItem = cart.items[itemIndex];
        
        if (cartItem && cartItem.properties) {
          console.log('📦 Cart item properties:', cartItem.properties);
          
          const sendDate = cartItem.properties['Send Date and Time'] || 
                           cartItem.properties['E-card Send Date'] || 
                           cartItem.properties['Ecard Send Date'];
          
          console.log('📅 Send date property value:', sendDate);
          
          // Check for both "Immediately" and "immediately" (case insensitive)
          if (sendDate && (sendDate === 'Immediately' || sendDate.toLowerCase() === 'immediately')) {
            console.log('🎯 Found "Immediately" value, checking checkbox...');
            
            // Check the checkbox
            sendImmediatelyCheckbox.checked = true;
            
            // Hide datetime picker
            if (datetimePickerField) {
              datetimePickerField.style.display = 'none';
            }
            
            // Make field not required
            ecardSendDateField.required = false;
            
            // Trigger change event to update UI
            sendImmediatelyCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
            
            console.log('✅ Successfully restored "send immediately" checkbox state');
          } else {
            console.log('📅 Specific datetime found, ensuring checkbox is unchecked');
            sendImmediatelyCheckbox.checked = false;
          }
        }
      })
      .catch(error => {
        console.error('❌ Error fetching cart data for checkbox fix:', error);
      });
  }
  
  console.log('✅ Card Personalization Edit: Initialization complete');
});
